/**
 * Determines if a char is sequenceable. Valid sequenceable chars are:
 *
 * Numbers: 0-9
 * Uppercase letters: A-Z
 * Lowercase letters: a-z
 */
export const isSequenceable = (charCode) => {
    if ((charCode >= 48 && charCode <= 57) || // 0-9
        (charCode >= 65 && charCode <= 90) || // A-Z
        (charCode >= 97 && charCode <= 122) // a-z
    ) {
        return true;
    }
    return false;
};
/**
 * Checks for the existence of 4 sequential characters anywhere in a string and
 * returns true if found. This is case sensitive.
 *
 * Examples:
 *  - 'abcd' // returns true
 *  - 'password123' // returns false
 *  - 'abc1234' // returns true
 *  - 'AbCdD' // returns false
 */
export const checkForSequentialChars = (str) => {
    const charMap = str.split('').map(s => s.charCodeAt(0));
    let sequentialCount = 0;
    for (let len = charMap.length, i = 0; i < len; i += 1) {
        const charA = charMap[i + 1];
        const charB = charMap[i];
        if (isSequenceable(charA) && isSequenceable(charB) && charA - charB === 1) {
            sequentialCount += 1;
        }
        else {
            sequentialCount = 0;
        }
        if (sequentialCount === 3) {
            return true;
        }
    }
    return false;
};
//# sourceMappingURL=checkForSequentialChars.js.map